"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPort = exports.getPorts = void 0;
const api_1 = require("@/services/api");
const ENDPOINT = "/ports";
function getPorts() {
    return api_1.axiosInstance
        .get(`${ENDPOINT}`)
        .then((response) => {
        return response.data.rows;
    })
        .catch((error) => {
        throw new Error(`[Ports Error]: ${error.message}`);
    });
}
exports.getPorts = getPorts;
function createPort(payload) {
    return api_1.axiosInstance.post(ENDPOINT, payload).then((response) => {
        return response.data;
    }).catch((error) => {
        throw new Error(`[Ports Error]: ${error.message}`);
    });
}
exports.createPort = createPort;
